<template>
  <div>
    <v-layout pt-12></v-layout>
    <v-layout pt-12></v-layout>
    <v-layout pt-12></v-layout>
    <v-layout fill-height grid-list-md text-xs-center>
      <v-flex>
        <v-flex xs12 md12>
          <v-img src="../../assets/icons/tick.png" aspect-ratio="1" contain height="50px">
          <template v-slot:placeholder>
            <v-row class="fill-height ma-0" align="center" justify="center">
              <v-progress-circular indeterminate color="#26af82"></v-progress-circular>
            </v-row>
          </template>
        </v-img>
        </v-flex>
        <v-flex xs12 md12 text-center>
          <span style="font-size:16px;font-weight:500;">You have successfully registered</span>
        </v-flex>
        <v-flex xs12 md12 text-center>
          <span style="font-size:14px;font-weight:400;color:#a9a9a9;">{{mailId}}</span>
        </v-flex>
        <v-flex xs12 md12 pt-3 pb-10 text-center>
          <router-link to="/Login">
            <v-btn
              width="220"
              :ripple="false"
              class="text-capitalize"
              color="#26af82"
              dark
              small
            >Login to Continue</v-btn>
          </router-link>
        </v-flex>
      </v-flex>
    </v-layout>
    <v-layout wrap justify-center pb-12></v-layout>
  </div>
</template>
<script>
export default {
  props: ["signupData"],
  data() {
    return {
      mailId: null
    };
  },
  mounted() {
    this.mailId = this.signupData.mailId;
  }
};
</script>
<style scoped>
.verimg.v-image__image--cover {
  background-size: contain !important;
}
</style>